<template>
  <div class="sidebar-wrapper" v-bind:class="{opened: openedMenu}" v-click-outside="closeForm">
    <div class="sidebar-header" v-if="openedMenu">
      <i class="toggle-icon" @click="toggleMenu"></i>
      <div>Charts for <span v-show="currentAdgroupName">{{currentAdgroupName}}</span></div>
    </div>
    <div class="sidebar-body">
      <div class="icons-wrapper">
        <div v-if="!openedMenu && showChartsButton">
          <i class="toggle-icon" @click="toggleMenu"></i>
        </div>
        <div v-show="openedMenu">
          <i class="charts-icon"></i>
        </div>
        <!--<div>
          <i class="edit-icon"></i>
        </div>-->
      </div>
      <div class="data-wrapper" v-if="openedMenu" ref="dataWrapper">
        <div class="chart-wrapper">
          <div class="metrics-wrapper">
            <div v-if="key != 'dateRanges'" v-for="(item, key, index) in chartsData"
                 v-bind:class="{active: (isMetricActive(key))}"
                 @click="useMetric(key, item)">
              <div>{{key}}</div>

              <template v-if="metricsListSum.includes(key)">
                <span>{{item.length > 0 ? item.reduce((a, b) => a + b) : null | roundValue | formatNumbers }}</span>
              </template>
              <template v-else-if="metricsListAvg.includes(key)">
                <span>{{item.length > 0 ? (item.reduce((a, b) => a + b) / item.length) : null | roundValue | formatNumbers }}</span>
              </template>
            </div>
          </div>
          <div class="chart flex">
              <highcharts v-if="topChartNumericSeries.leftChart.length" :options="topLeftChartNumericMetricsOption"></highcharts>
              <highcharts v-if="topChartNumericSeries.rightChart.length" :options="topRightChartNumericMetricsOption"></highcharts>
          </div>
          <div class="chart flex">
            <highcharts v-if="bottomChartCurrencySeries.leftChart.length" :options="bottomLeftChartCurrencyMetricsOption"></highcharts>
            <highcharts v-if="bottomChartCurrencySeries.rightChart.length" :options="bottomRightChartCurrencyMetricsOption"></highcharts>
          </div>
          <div class="chart flex">
            <highcharts v-if="series.length" :options="restDataChart"></highcharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import VueHighcharts from 'vue-highcharts';
  import Vue from 'vue';
  import { isArray, isObject } from '../../../../helpers/check_variable_types.js';

  Vue.use(VueHighcharts);

  export default {
    name: "cc-table-right-side-bar",
    props: {
      data: {
        type: [Object, Array],
        required: false
      },
      namespace: {
        type: String,
        required: true
      },
      showChartsButton: {
        type: Boolean,
        required: false
      }
    },
    components: {
      VueHighcharts
    },
    data() {
      return {
        currentAdgroupName: null,
        series: [],
        categories: [],
        metricsListSum: ['boughtClicks', 'cost', 'soldClicks', 'revenue', 'profit', 'conversions'],
        metricsListAvg: ['adCtr', 'cpc', 'opCtr', 'rps', 'rpc', 'tq'],
        selectAll: false,
        chartsWidth: null,
        topChartNumericSeries: {
          leftChart: [],
          rightChart: []
        },
        bottomChartCurrencySeries: {
          leftChart: [],
          rightChart: []
        }
      }
    },
    watch: {
      data: function (value) {
        this.series = [];
        this.selectAll = true;

        this.topChartNumericSeries.leftChart = [];
        this.topChartNumericSeries.rightChart = [];
        this.bottomChartCurrencySeries.leftChart = [];
        this.bottomChartCurrencySeries.rightChart = [];
      },
    },
    computed: {
      openedMenu: {
        set(status) {
          this.$store.dispatch(this.namespace + '/setSideBarStatus', status);
        },
        get() {
          return this.$store.getters[this.namespace + '/getSideBarStatus'];
        }
      },
      dataWrapper: function(){
        if (this.$refs.dataWrapper !== undefined) {
          return this.$refs.dataWrapper.clientWidth;
        }

        return null;
      },
      chartsData: function () {

        let that = this;

        if (isArray(this.data)) {
          if (this.data.length > 0) {
            this.categories = [];

            let metricsItems = {
              dateRanges: [],
              boughtClicks: [],
              soldClicks: [],
              opCtr: [],
              adCtr: [],
              cost: [],
              revenue: [],
              profit: [],
              cpc: [],
              rps: [],
              rpc: [],
            };

            this.currentAdgroupName = this.data[0].node.siteName + ', ' + this.data[0].node.sourceName;

            this.data.map(function (item) {
              let values = item.node.metrics[0];
              let date = item.node.date;

              metricsItems.dateRanges.push(date);
              metricsItems.boughtClicks.push(values.boughtClicks);
              metricsItems.adCtr.push(values.adCtr);
              metricsItems.cost.push(values.cost);
              metricsItems.cpc.push(values.cpc);
              metricsItems.soldClicks.push(values.soldClicks);
              metricsItems.revenue.push(values.revenue);
              metricsItems.opCtr.push(values.opCtr);
              metricsItems.rps.push(values.rps);
              metricsItems.rpc.push(values.rpc);
              metricsItems.profit.push(values.profit);

              if (date !== undefined) {
                that.categories.push(date);
              }
            });

            if (this.topChartNumericSeries.leftChart == 0 && this.selectAll) {
              this.setTopLeftChartNumericSeriesData(metricsItems);
            }

            if (this.topChartNumericSeries.rightChart == 0 && this.selectAll) {
              this.setTopRightChartNumericSeriesData(metricsItems);
            }

            if (this.bottomChartCurrencySeries.leftChart == 0 && this.selectAll) {
              this.setBottomLeftChartCurrencySeriesData(metricsItems);
            }

            if (this.bottomChartCurrencySeries.rightChart == 0 && this.selectAll) {
              this.setBottomRightChartCurrencySeriesData(metricsItems);
            }

            if (this.series == 0 && this.selectAll) {
              this.setRestSeriesData(metricsItems);
            }

            this.selectAll = false;

            return metricsItems;
          }
        }
        else if (isObject(this.data)) {
          if (this.data !== null) {
            this.categories = [];

            let metricsData = this.data.metrics;

            this.currentAdgroupName = 'Ad Group: ' + this.data.adGroupName;

            let metricsItems = {
              dateRanges: [],
              boughtClicks: [],
              adCtr: [],
              cost: [],
              cpc: [],
              soldClicks: [],
              revenue: [],
              opCtr: [],
              rps: [],
              rpc: [],
              profit: [],
              tq: [],
              conversions: []
            };

            metricsData.map(function (item) {
              if (item.dateRange !== undefined) {
                let startDate = item.dateRange.split(',')[0];

                metricsItems.dateRanges.push(startDate);
                metricsItems.boughtClicks.push(item.boughtClicks);
                metricsItems.adCtr.push(item.adCtr);
                metricsItems.cost.push(item.cost);
                metricsItems.cpc.push(item.cpc);
                metricsItems.soldClicks.push(item.soldClicks);
                metricsItems.revenue.push(item.revenue);
                metricsItems.opCtr.push(item.opCtr);
                metricsItems.rps.push(item.rps);
                metricsItems.rpc.push(item.rpc);
                metricsItems.profit.push(item.profit);
                metricsItems.tq.push(item.tq);
                metricsItems.conversions.push(item.conversions);

                if (startDate !== undefined) {
                  that.categories.push(startDate);
                }
              }
            });

            if (this.topChartNumericSeries.leftChart == 0 && this.selectAll) {
              this.setTopLeftChartNumericSeriesData(metricsItems);
            }

            if (this.topChartNumericSeries.rightChart == 0 && this.selectAll) {
              this.setTopRightChartNumericSeriesData(metricsItems);
            }

            if (this.bottomChartCurrencySeries.leftChart == 0 && this.selectAll) {
              this.setBottomLeftChartCurrencySeriesData(metricsItems);
            }

            if (this.bottomChartCurrencySeries.rightChart == 0 && this.selectAll) {
              this.setBottomRightChartCurrencySeriesData(metricsItems);
            }

            if (this.series == 0 && this.selectAll) {
              this.setRestSeriesData(metricsItems);
            }

            this.selectAll = false;

            return metricsItems;
          }
        }
      },
      options: function () {
        if (this.data !== null) {
          return {
            chart: {
              type: 'spline',
              zoomType: 'xy'
            },
            title: {
              text: this.categories.length + ' ' + 'days range view',
              x: -20 //center
            },
            xAxis: {
              categories: this.categories
            },
            yAxis: {
              plotLines: [{
                value: 0,
                width: 1,
                color: '#808080'
              }]
            },
            tooltip: {
              pointFormat: "{series.name}: {point.y:,.2f}"
            },
            legend: {
              layout: 'vertical',
              align: 'right',
              verticalAlign: 'middle',
              borderWidth: 0
            },
            series: this.series
          };
        }
      },
      topLeftChartNumericMetricsOption: function () {
        if (this.data !== null) {
          return {
            chart: {
              type: 'spline',
              zoomType: 'xy',
              width: this.dataWrapper !== null ? this.dataWrapper / 2 : '500'
            },
            title: {
              text: this.categories.length + ' ' + 'days range view',
              x: -20 //center
            },
            xAxis: {
              categories: this.categories
            },
            yAxis: //[
              {
                labels: {
                  format: '{value}',
                  style: {
                    color: this.Highcharts.getOptions().colors[1]
                  }
                },
                /*title: {
                  text: 'Bought Clicks',
                  style: {
                    color: this.Highcharts.getOptions().colors[1]
                  }
                }*/
              },
              /*{
                title: {
                  text: 'Sold Clicks',
                  style: {
                    color: this.Highcharts.getOptions().colors[0]
                  },
                },
                labels: {
                  format: '{value}',
                  style: {
                    color: this.Highcharts.getOptions().colors[0]
                  }
                },
                opposite: true
              }*/
            //],
            tooltip: {
              pointFormat: "{series.name}: {point.y:,.2f}"
            },
            legend: {
              layout: 'vertical',
              align: 'right',
              verticalAlign: 'middle',
              borderWidth: 0
            },
            series: this.topChartNumericSeries.leftChart,
            responsive: {
              rules: [{
                condition: {
                  maxWidth: 500,
                  minWidth: 300
                },
                chartOptions: {
                  chart: {
                    height: 300
                  },
                  subtitle: {
                    text: null
                  },
                  navigator: {
                    enabled: false
                  }
                }
              }]
            }
          };
        }
      },
      topRightChartNumericMetricsOption: function () {
        if (this.data !== null) {
          return {
            chart: {
              type: 'spline',
              zoomType: 'xy',
              width: this.dataWrapper !== null ? this.dataWrapper / 2 : '500'
            },
            title: {
              text: this.categories.length + ' ' + 'days range view',
              x: -20 //center
            },
            xAxis: {
              categories: this.categories
            },
            yAxis: [
              {
                labels: {
                  format: '{value} %',
                  style: {
                    color: this.Highcharts.getOptions().colors[1]
                  }
                },
                title: {
                  text: 'opCTR',
                  style: {
                    color: this.Highcharts.getOptions().colors[1]
                  }
                }
              },
              {
                title: {
                  text: 'adCTR',
                  style: {
                    color: this.Highcharts.getOptions().colors[0]
                  },
                },
                labels: {
                  format: '{value} %',
                  style: {
                    color: this.Highcharts.getOptions().colors[0]
                  }
                },
                opposite: true
              }
            ],
            tooltip: {
              pointFormat: "{series.name}: {point.y:,.2f}"
            },
            legend: {
              layout: 'vertical',
              align: 'right',
              verticalAlign: 'middle',
              borderWidth: 0
            },
            series: this.topChartNumericSeries.rightChart,
            responsive: {
              rules: [{
                condition: {
                  maxWidth: 500,
                  minWidth: 200
                },
                chartOptions: {
                  chart: {
                    height: 300
                  },
                  subtitle: {
                    text: null
                  },
                  navigator: {
                    enabled: false
                  }
                }
              }]
            }
          };
        }
      },
      bottomLeftChartCurrencyMetricsOption: function () {
        if (this.data !== null) {
          return {
            chart: {
              type: 'spline',
              zoomType: 'xy',
              width: this.dataWrapper !== null ? this.dataWrapper / 2 : '500'
            },
            title: {
              text: this.categories.length + ' ' + 'days range view',
              x: -20 //center
            },
            xAxis: {
              categories: this.categories
            },
            yAxis: [
              {
                labels: {
                  format: '{value} $',
                  style: {
                    color: this.Highcharts.getOptions().colors[1]
                  }
                },
                title: {
                  text: 'Cost, Revenue',
                  style: {
                    color: this.Highcharts.getOptions().colors[1]
                  }
                }
              },
              {
                title: {
                  text: 'Profit',
                  style: {
                    color: this.Highcharts.getOptions().colors[0]
                  },
                },
                labels: {
                  format: '{value} $',
                  style: {
                    color: this.Highcharts.getOptions().colors[0]
                  }
                },
                opposite: true
              }
            ],
            tooltip: {
              pointFormat: "{series.name}: {point.y:,.2f}"
            },
            legend: {
              layout: 'vertical',
              align: 'right',
              verticalAlign: 'middle',
              borderWidth: 0
            },
            series: this.bottomChartCurrencySeries.leftChart,
            responsive: {
              rules: [{
                condition: {
                  maxWidth: 500,
                  minWidth: 200
                },
                chartOptions: {
                  chart: {
                    height: 300
                  },
                  subtitle: {
                    text: null
                  },
                  navigator: {
                    enabled: false
                  }
                }
              }]
            }
          };
        }
      },
      bottomRightChartCurrencyMetricsOption: function () {
        if (this.data !== null) {
          return {
            chart: {
              type: 'spline',
              zoomType: 'xy',
              width: this.dataWrapper !== null ? this.dataWrapper / 2 : '500'
            },
            title: {
              text: this.categories.length + ' ' + 'days range view',
              x: -20 //center
            },
            xAxis: {
              categories: this.categories
            },
            yAxis: [
              {
                labels: {
                  format: '{value} $',
                  style: {
                    color: this.Highcharts.getOptions().colors[1]
                  }
                },
                title: {
                  text: 'CPC, RPC',
                  style: {
                    color: this.Highcharts.getOptions().colors[1]
                  }
                }
              },
              {
                title: {
                  text: 'RPS',
                  style: {
                    color: this.Highcharts.getOptions().colors[0]
                  },
                },
                labels: {
                  format: '{value} $',
                  style: {
                    color: this.Highcharts.getOptions().colors[0]
                  }
                },
                opposite: true
              }
            ],
            tooltip: {
              pointFormat: "{series.name}: {point.y:,.2f}"
            },
            legend: {
              layout: 'vertical',
              align: 'right',
              verticalAlign: 'middle',
              borderWidth: 0
            },
            series: this.bottomChartCurrencySeries.rightChart,
            responsive: {
              rules: [{
                condition: {
                  maxWidth: 500,
                  minWidth: 200
                },
                chartOptions: {
                  chart: {
                    height: 300
                  },
                  subtitle: {
                    text: null
                  },
                  navigator: {
                    enabled: false
                  }
                }
              }]
            }
          };
        }
      },
      restDataChart: function () {
        if (this.data !== null) {
          return {
            chart: {
              type: 'spline',
              zoomType: 'xy',
              width: this.dataWrapper !== null ? this.dataWrapper / 2 : '500'
            },
            title: {
              text: this.categories.length + ' ' + 'days range view',
              x: -20 //center
            },
            xAxis: {
              categories: this.categories
            },
            yAxis: {
              labels: {
                format: '{value} $',
                style: {
                  color: this.Highcharts.getOptions().colors[1]
                }
              },
              title: {
                style: {
                  color: this.Highcharts.getOptions().colors[1]
                }
              }
            },
            tooltip: {
              pointFormat: "{series.name}: {point.y:,.2f}"
            },
            legend: {
              layout: 'vertical',
              align: 'right',
              verticalAlign: 'middle',
              borderWidth: 0
            },
            series: this.series,
            responsive: {
              rules: [{
                condition: {
                  maxWidth: 500,
                  minWidth: 200
                },
                chartOptions: {
                  chart: {
                    height: 300
                  },
                  subtitle: {
                    text: null
                  },
                  navigator: {
                    enabled: false
                  }
                }
              }]
            }
          };
        }
      }
    },
    filters: {
      formatNumbers: function (value) {

        if (value != undefined && !isNaN(value)) {
          return value.toLocaleString('en-US', {maximumFractionDigits: 2});
        }

        return value;
      },
      roundValue: function (value) {

        let precision = 2;

        if (value !== undefined && !isNaN(value)) {
          let factor = Math.pow(10, precision);
          return Math.round(value * factor) / factor;
        }

        return value;
      }
    },
    methods: {
      toggleMenu: function () {
        this.openedMenu = !this.openedMenu;
      },
      useMetric: function (metric, value) {
        let seriesName = this.series;
        let yAxis = 0;

        if (['boughtClicks', 'soldClicks'].includes(metric)) {
          if (metric == 'soldClicks') {
            //yAxis = 1;
          }

          seriesName = this.topChartNumericSeries.leftChart;
        }
        else if (['adCtr', 'opCtr'].includes(metric)) {
          if (metric == 'adCtr') {
            yAxis = 1;
          }

          seriesName = this.topChartNumericSeries.rightChart;
        }

        if (['cost', 'revenue', 'profit'].includes(metric)) {
          if (metric == 'profit') {
            yAxis = 1;
          }

          seriesName = this.bottomChartCurrencySeries.leftChart;
        }
        else if (['rpc', 'rps', 'cpc'].includes(metric)) {
          if (metric == 'rps') {
            yAxis = 1;
          }

          seriesName = this.bottomChartCurrencySeries.rightChart;
        }

        let itemIndex = seriesName.findIndex(item => item.name == metric);

        if (itemIndex !== -1) {
          seriesName.splice(itemIndex, 1);
        }
        else {
          seriesName.push({
            name: metric,
            data: value,
            yAxis: yAxis
          });
        }
      },
      isMetricActive: function (metric) {

        let seriesName = this.series;

        if (['boughtClicks', 'soldClicks'].includes(metric)) {
          seriesName = this.topChartNumericSeries.leftChart;
        }
        else if (['adCtr', 'opCtr'].includes(metric)) {
          seriesName = this.topChartNumericSeries.rightChart;
        }

        if (['cost', 'revenue', 'profit'].includes(metric)) {
          seriesName = this.bottomChartCurrencySeries.leftChart;
        }
        else if (['rpc', 'rps', 'cpc'].includes(metric)) {
          seriesName = this.bottomChartCurrencySeries.rightChart;
        }

        let itemIndex = seriesName.findIndex(item => item.name == metric);

        if (itemIndex !== -1) {
          return true;
        }

        return false;
      },
      closeForm: function () {
        this.openedMenu = false;
      },
      setTopLeftChartNumericSeriesData: function (metricsItems) {
        for (var metricName in metricsItems) {
          if (['boughtClicks', 'soldClicks'].includes(metricName)) {
            this.topChartNumericSeries.leftChart.push({
              name: metricName,
              data: metricsItems[metricName]
            });
          }
        }
      },
      setTopRightChartNumericSeriesData: function (metricsItems) {
        for (var metricName in metricsItems) {
          if (['adCtr', 'opCtr'].includes(metricName)) {
            let yAxis = 0;

            if (metricName == 'adCtr') {
              yAxis = 1;
            }

            this.topChartNumericSeries.rightChart.push({
              name: metricName,
              data: metricsItems[metricName],
              yAxis: yAxis
            });
          }
        }
      },
      setBottomLeftChartCurrencySeriesData: function (metricsItems) {
        for (var metricName in metricsItems) {
          if (['cost', 'revenue', 'profit'].includes(metricName)) {

            let yAxis = 0;

            if (metricName == 'profit') {
              yAxis = 1;
            }

            this.bottomChartCurrencySeries.leftChart.push({
              name: metricName,
              data: metricsItems[metricName],
              yAxis: yAxis
            });
          }
        }
      },
      setBottomRightChartCurrencySeriesData: function (metricsItems) {
        for (var metricName in metricsItems) {
          if (['rpc', 'rps', 'cpc'].includes(metricName)) {

            let yAxis = 0;

            if (metricName == 'cpc') {
              yAxis = 1;
            }

            this.bottomChartCurrencySeries.rightChart.push({
              name: metricName,
              data: metricsItems[metricName],
              yAxis: yAxis
            })
          }
        }
      },
      setRestSeriesData: function (metricsItems) {
        for (var metricName in metricsItems) {
          if (![
              'dateRanges', 'rpc', 'rps', 'cpc', 'cost', 'revenue', 'profit', 'adCtr',
              'opCtr', 'boughtClicks', 'soldClicks'
            ].includes(metricName)
          ) {
            if (metricName !== 'dateRanges' && (metricsItems[metricName].reduce((x, y) => x + y) != 0)) {
              this.series.push({
                name: metricName,
                data: metricsItems[metricName]
              });
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sidebar-wrapper {
    background-color: #7d7d7d;
    /*border: 1px solid #979797;*/

    & > div.sidebar-body {

      display: grid;
      grid-template-columns: 64px auto;

      & > .icons-wrapper {
        width: 64px;

        & > div {
          border-bottom: 1px solid #979797;

          & > i {
            display: inline-block;
            width: 64px;
            height: 64px;
            cursor: pointer;
          }
        }

        .toggle-icon {
          background: url('/static/img/right-sidebar-toggle-icon.svg') center no-repeat;
        }

        .charts-icon {
          background: url('/static/img/right-sidebar-charts-icon.svg') center no-repeat;
        }

        .edit-icon {
          background: url('/static/img/right-sidebar-edit-icon.svg') center no-repeat;
        }
      }
    }

    &.opened{
      position:absolute;
      z-index: 5;
      right: 0;
      width: 80vw;
      margin-right: 25px;
      border-bottom: 1px solid #979797;
      box-shadow: 1px 3px 7px 1px #cbcccd;

      & > div.sidebar-header {
        height: 64px;
        display: flex;
        background-color: #525252;

        .toggle-icon {
          display: inline-block;
          width: 64px;
          height: 64px;
          background: url('/static/img/right-sidebar-toggle-icon.svg') center no-repeat;
          transform: rotateY(180deg);
          cursor: pointer;
        }

        & > div {
          color: #fff;
          margin: auto 0;
          margin-left: 25px;
          font-size: 20px;
        }

      }

      & > div.sidebar-body {
        height: 100%;

        & > .icons-wrapper {

          & > div {
            border: 0;
          }

          .charts-icon {
            background: #fff url('/static/img/icon-charts-showed.svg') center no-repeat;
          }

        }

        & > .data-wrapper {
          background-color: #f0f0f0;

          & > .chart-wrapper {
            background-color: #fff;
            padding-bottom: 15px;
            width: 100%;

            & > .metrics-wrapper {
              display: grid;
              grid-template-columns: repeat(auto-fill,minmax(130px, 1fr));
              padding: 15px;
              grid-gap: 10px;

              & > div {
                width: 130px;
                padding: 15px;
                border: 1px solid $border-color;
                border-radius: 5px;
                margin-right: 15px;
                text-align: left;
                cursor: pointer;
                font-size: 14px;

                &.active {
                  border: 1px solid #4a90e2;
                }

                & > div {
                  padding-bottom: 5px;
                }

                & > span {
                  font-weight: bold;
                }
              }

            }
          }
        }

      }
    }
  }

  .chart.flex {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  @include mobile-only {
    .sidebar-wrapper {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/reports/common/table/CCTableRightSideBar.vue